import type { FC } from 'react';
import type { TermStructureProps } from './types';
import TermStructureWidget from './term-structure-widget';
import { DataLabelEnum } from '../../../../model/data_label.enum';
import { VolSmileDataType, VolSmileProvider } from '../../../../providers/widgets';
import { GetVolProvider } from '../../../../providers/get-vol-provider';

const TermStructureWrapperProvider: FC<TermStructureProps> = (props) => (
  <GetVolProvider label={DataLabelEnum.PERPETUAL} providerKey={props.providerKey}>
    <VolSmileProvider dataType={VolSmileDataType.termStructure} providerKey={props.providerKey}>
      <TermStructureWidget {...props} />
    </VolSmileProvider>
  </GetVolProvider>
);

export default TermStructureWrapperProvider;
